import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState } from '@reducers/v2/planboard/types';

export const clearMachineRefetchAction = (state: PlanboardState, action: PayloadAction<number>) => {
  const machineId = action.payload;
  state.machineColumnsNeedingRefetch = state.machineColumnsNeedingRefetch.filter((id) => id !== machineId);
};
